import { EventType } from '../../catalog/enums/EventType';
import { db } from '../FirebaseLibrary';

export const createEventsReference = () => {
    return db.collection('events');
};

export const createEventReference = (eventId: string) => {
    return createEventsReference().doc(eventId);
};

export const fetchEventFirestoreAPI = (eventId: string) => {
    return createEventReference(eventId).get();
};

export const fetchUpcomingEventsAndPracticeFirestoreAPI = (teamId: string) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('timeOfEvent', '>=', myDate)
        .orderBy('timeOfEvent')
        .get();
};

export const fetchPastEventsAndPracticeFirestoreAPI = (teamId: string) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('timeOfEvent', '<=', myDate)
        .orderBy('timeOfEvent', 'desc')
        .get();
};

export const fetchUpcomingEventsFirestoreAPI = (teamId: string) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.EVENT)
        .where('timeOfEvent', '>=', myDate)
        .orderBy('timeOfEvent')
        .get();
};

export const fetchPastEventsFirestoreAPI = (teamId: string) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.EVENT)
        .where('timeOfEvent', '<=', myDate)
        .orderBy('timeOfEvent', 'desc')
        .get();
};

export const fetchUpcomingPracticesFirestoreAPI = (teamId: string) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.PRACTICE)
        .where('timeOfEvent', '>=', myDate)
        .orderBy('timeOfEvent')
        .get();
};

export const fetchPastPracticesFirestoreAPI = (teamId: string) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.PRACTICE)
        .where('timeOfEvent', '<=', myDate)
        .orderBy('timeOfEvent', 'desc')
        .get();
};

export const fetchLimitedUpcomingEventsAndPracticeFirestoreAPI = (teamId: string, count: number) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('timeOfEvent', '>=', myDate)
        .orderBy('timeOfEvent')
        .limit(count)
        .get();
};

export const fetchLimitedPastEventsAndPracticeFirestoreAPI = (teamId: string, count: number) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('timeOfEvent', '<=', myDate)
        .orderBy('timeOfEvent', 'desc')
        .limit(count)
        .get();
};

export const fetchLimitedUpcomingEventsFirestoreAPI = (teamId: string, count: number) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.EVENT)
        .where('timeOfEvent', '>=', myDate)
        .orderBy('timeOfEvent')
        .limit(count)
        .get();
};

export const fetchLimitedPastEventsFirestoreAPI = (teamId: string, count: number) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.EVENT)
        .where('timeOfEvent', '<=', myDate)
        .orderBy('timeOfEvent', 'desc')
        .limit(count)
        .get();
};

export const fetchLimitedUpcomingPracticeFirestoreAPI = (teamId: string, count: number) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.PRACTICE)
        .where('timeOfEvent', '>=', myDate)
        .orderBy('timeOfEvent')
        .limit(count)
        .get();
};

export const fetchLimitedPastPracticeFirestoreAPI = (teamId: string, count: number) => {
    const myDate = new Date();
    myDate.setHours(0);
    myDate.setMinutes(0);
    myDate.setSeconds(0);

    return createEventsReference().where('teamId', '==', teamId).where('published', '==', true).where('eventType', '==', EventType.PRACTICE)
        .where('timeOfEvent', '<=', myDate)
        .orderBy('timeOfEvent', 'desc')
        .limit(count)
        .get();
};
